export default __webpack_public_path__ + "static/media/tradeup-logo.cb64369a.svg";